@if (filtersForm() && controlName()) {
  <vectronic-filter-header
    (titleClicked)="toggleShowFilter()"
    title="{{ title() }}"
    [svgIcon]="svgIcon()"
    [icon]="icon()"
    (enabledFilterToggle)="toggleShowFilter()"
    [isFilterEnabled]="isFilterHidden()"
  ></vectronic-filter-header>

  <!-- multi select dropwn fitler -->
  <div
    class="origin-filter filter-body"
    [formGroup]="filtersForm()"
    [hidden]="!isFilterHidden()"
    (click)="filtersForm().get(filterEnableControl()).setValue(true)"
  >
    <div class="origin-filter__container">
      <mat-form-field class="origin-filter__form-field" appearance="outline">
        <mat-label>{{ title() }}</mat-label>
        <mat-select
          [formControlName]="controlName()"
          multiple
          [value]="filtersForm().get(controlName()).value"
        >
          @if (title() === FilterTitles.MORTALITY_STATUS) {
            @for (item of filterList.mortalityStatusFilterList; track item) {
              <mat-option [value]="item.item">{{ item.label }}</mat-option>
            }
          } @else if (title() === FilterTitles.MORTALITY_TYPE) {
            @for (item of filterList.mortalityTypeFilterList; track item) {
              <mat-option [value]="item.value">{{ item.name }}</mat-option>
            }
          } @else if (title() === FilterTitles.EVENT) {
            @if (pageName() === 'Separation' || pageName() === 'Separations') {
              @for (item of filterList.separationTypeFilterList; track item) {
                <mat-option [value]="item.value">{{ item.name }}</mat-option>
              }
            }
            @if (pageName() === 'VaginalImplant' || pageName() === 'Vaginal Implants') {
              @for (item of filterList.vaginalImplantFilterList; track item) {
                <mat-option [value]="item.value">{{ item.name }}</mat-option>
              }
            }
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
}
